(() => {
  const selectors = {
    focusable: 'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
  };

  class PMXPassageHeader extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.disclosures = [...this.querySelectorAll('[data-pmx-header-disclosure]')];
      this.dialog = this.querySelector('[data-pmx-menu-dialog]');
      this.launcher = this.querySelector('[data-pmx-menu-open]');
      this.closer = this.querySelector('[data-pmx-menu-close]');
      this.abort = new AbortController();
      const { signal } = this.abort;

      this.disclosures.forEach((disclosure) => {
        disclosure.addEventListener('toggle', () => {
          if (!disclosure.open) return;
          this.disclosures.forEach((item) => {
            if (item !== disclosure) item.open = false;
          });
        }, { signal });
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.disclosures.forEach((item) => { item.open = false; });
        }
      }, { signal });

      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) {
          this.disclosures.forEach((item) => { item.open = false; });
        }
      }, { signal });

      this.launcher?.addEventListener('click', () => this.openDialog(), { signal });
      this.closer?.addEventListener('click', () => this.closeDialog(), { signal });
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeDialog();
      }, { signal });
      this.dialog?.addEventListener('close', () => this.launcher?.focus(), { signal });
      this.dialog?.addEventListener('keydown', (event) => this.trapDialogFocus(event), { signal });

      this.searchHandles = [];
      this.searches = [...this.querySelectorAll('[data-pmx-header-search]')];
      this.searches.forEach((search) => this.initSearch(search));
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.searchHandles?.forEach((handle) => handle.destroy());
      this.searchHandles = [];
      this.initialized = false;
    }

    openDialog() {
      if (!this.dialog?.showModal) return;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => this.dialog.querySelector(selectors.focusable)?.focus());
    }

    closeDialog() {
      if (!this.dialog?.open) return;
      this.dialog.close();
      document.documentElement.style.overflow = '';
    }

    trapDialogFocus(event) {
      if (event.key !== 'Tab') return;
      const focusable = [...this.dialog.querySelectorAll(selectors.focusable)]
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    initSearch(search) {
      // One shared behaviour with the passage search — see pmx-search.js.
      // Without it the form is still a plain GET to the search route.
      const handle = window.PMXSearch?.attach({
        root: search,
        form: search.querySelector('form'),
        input: search.querySelector('[data-pmx-search-input]'),
        panel: search.querySelector('[data-pmx-search-results]'),
        status: search.querySelector('[data-pmx-search-status]'),
        predictiveEndpoint: search.dataset.endpoint,
        predictiveSection: search.dataset.section,
        semanticEndpoint: search.dataset.semanticEndpoint,
        semanticLabel: search.dataset.semanticLabel,
      });
      if (handle) this.searchHandles.push(handle);
    }
  }

  if (!customElements.get('pmx-passage-header')) {
    customElements.define('pmx-passage-header', PMXPassageHeader);
  }
})();
